var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgLevel1 = function SvgLevel1(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 16,
    viewBox: "0 0 46 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 45,
    height: 16,
    rx: 8,
    fill: "#92BE9A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9631 4.3H14.0631V11.043H18.2321V12H12.9631V4.3ZM24.0804 6.17L21.5284 12H20.4504L17.8984 6.17H18.9984L21.0004 10.845L23.0464 6.17H24.0804ZM24.9537 12.066C24.7484 12.066 24.5724 11.9963 24.4257 11.857C24.279 11.7103 24.2057 11.527 24.2057 11.307C24.2057 11.0943 24.279 10.9183 24.4257 10.779C24.5724 10.6323 24.7484 10.559 24.9537 10.559C25.159 10.559 25.3314 10.6287 25.4707 10.768C25.61 10.9073 25.6797 11.087 25.6797 11.307C25.6797 11.527 25.6064 11.7103 25.4597 11.857C25.3204 11.9963 25.1517 12.066 24.9537 12.066Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2452 4.3V12H30.4632V5.73H28.9232V4.3H32.2452Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLevel1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "apps/static/media/level1.46e9b221597b0ea998e74846bdd250cb.blank.svg";